import Model from "./Model";

export default class Disciplina extends Model {
  constructor(disciplina) {
    super();
    Object.assign(this, disciplina);
  }
}
